import { TranslateFunc } from '@prisjakt/ui-translate/src/translate-func';
import { AdvizedTest, AdvizedToplist, ExpertGuide } from '../../../types';
import { ContentTypes } from 'src/areas/expert/types';

type Item = AdvizedTest | AdvizedToplist | ExpertGuide | any | null;

/**
 * Compare function for sorting Adviced content in arrays
 */
export const compareByDate = (a: Item, b: Item) => {
  // If null or undefined, move to bottom of list
  if (!a || !a.publishedAt) return 1;
  if (!b || !b.publishedAt) return -1;
  return parseInt(b.publishedAt, 10) - parseInt(a.publishedAt, 10);
};

export const getTranslationByContentType = (
  type: ContentTypes,
  t: TranslateFunc
) => {
  switch (type) {
    case ContentTypes.TEST:
      return t('expert', 'test.test');
    case ContentTypes.TOPLIST:
    case ContentTypes.TOPLIST_HEADLINE:
      return t('expert', 'toplist.toplist');
    case ContentTypes.GUIDE:
      return t('expert', 'guide.guide');

    default:
      return null;
  }
};
